"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stipParamsFromDidUrl = exports.validateDidMethodSupported = void 0;
const _defaultConfig_1 = require("./_defaultConfig");
exports.validateDidMethodSupported = (didMethod) => {
    if (!_defaultConfig_1.SUPPORTED_DID_METHODS.includes(didMethod)) {
        throw new Error(`${didMethod} is not supported did method, supported: ${_defaultConfig_1.SUPPORTED_DID_METHODS.toString()}`);
    }
};
exports.stipParamsFromDidUrl = (did) => did
    // Strip out matrix params
    .replace(/;[a-zA-Z0-9_.:%-]+=[a-zA-Z0-9_.:%-]*/g, '')
    // Strip out query params
    .replace(/([?][^#]*)?/g, '');
//# sourceMappingURL=_helpers.js.map